export default {"src":"/_next/static/media/redbellpepper.53db0cc2.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};